function Button({ text }) {
  return (
    <button className="px-4 py-2 text-center text-white uppercase bg-primary text-20">
      {text}
    </button>
  );
}

export default Button;
